import axiosInstance from "./axiosConfig";

/**
 * Get all attributes for a category
 * @param {string} categoryId - Category ID
 * @returns {Array} List of attributes for the category
 */
const getCategoryAttributes = async (categoryId) => {
  const response = await axiosInstance.get(
    `/categories/${categoryId}/attributes`
  );
  return response.data;
};

/**
 * Assign an attribute to a category
 * @param {string} categoryId - Category ID
 * @param {Object} attributeData - Attribute data to assign
 * @param {string} attributeData.attributeId - Attribute ID
 * @param {boolean} attributeData.isRequired - Whether the attribute is required
 * @param {boolean} attributeData.isVariantable - Whether the attribute is used for product variations
 * @param {number} attributeData.displayOrder - Display order of the attribute
 * @returns {Object} Created category-attribute relationship
 */
const assignAttributeToCategory = async (categoryId, attributeData) => {
  const response = await axiosInstance.post(
    `/categories/${categoryId}/attributes`,
    attributeData
  );
  return response.data;
};

/**
 * Update a category-attribute relationship
 * @param {string} categoryId - Category ID
 * @param {string} attributeId - Attribute ID
 * @param {Object} updateData - Data to update
 * @param {boolean} updateData.isRequired - Whether the attribute is required
 * @param {boolean} updateData.isVariantable - Whether the attribute is used for product variations
 * @param {number} updateData.displayOrder - Display order of the attribute
 * @returns {Object} Updated category-attribute relationship
 */
const updateCategoryAttribute = async (categoryId, attributeId, updateData) => {
  const response = await axiosInstance.put(
    `/categories/${categoryId}/attributes/${attributeId}`,
    updateData
  );
  return response.data;
};

/**
 * Remove an attribute from a category
 * @param {string} categoryId - Category ID
 * @param {string} attributeId - Attribute ID
 * @returns {Object} Success message
 */
const removeAttributeFromCategory = async (categoryId, attributeId) => {
  const response = await axiosInstance.delete(
    `/categories/${categoryId}/attributes/${attributeId}`
  );
  return response.data;
};

const categoryAttributeService = {
  getCategoryAttributes,
  assignAttributeToCategory,
  updateCategoryAttribute,
  removeAttributeFromCategory,
};

export default categoryAttributeService;
